
  import { defineComponent } from 'vue';

  import constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import AggregatedPageWrapper from '../components/common/AggregatedPageWrapper.vue';
  import { TExportConfig } from '../components/common/ved-aggregated-export-buttons/types';
  import ForeignTradeByProductsBaseInfo from '../components/foreign-trade-by-products/ForeignTradeByProductsBaseInfo.vue';
  import ForeignTradeByProductsFilter from '../components/foreign-trade-by-products/ForeignTradeByProductsFilter.vue';
  import ForeignTradeByProductsTable from '../components/foreign-trade-by-products/ForeignTradeByProductsTable.vue';
  import {
    IndicatorTypes,
    SelectTypes,
    TradeDirections,
    TreeCountryValues,
    TreeRegionRFValues,
  } from '../types/common-aggregated';
  import type { TForeignTradeByProductsFilter } from '../types/foreign-trade-by-products';
  import { TAggregatedPermissions } from '../types/permission';
  import { getFilenameWithPeriod } from '../utils/filename';

  import links from '@/utils/links';

  const DEFAULT_FILTER: TForeignTradeByProductsFilter = {
    periods: ['2011', '2011-M1', '2011-M2', '2012'],
    regionsRf: [TreeRegionRFValues.RF],
    countries: [TreeCountryValues.GERMANY_99],
    tradeDirectionId: TradeDirections.EXPORT,
    selectTypeId: SelectTypes.CUMULATIVE_TOTAL,
    amountSigns: 0,
    indicatorTypeId: IndicatorTypes.PRICE_AND_WEIGHT,
  };

  export default defineComponent({
    name: 'ForeignTradeByProducts',
    components: {
      AggregatedPageWrapper,
      ForeignTradeByProductsFilter,
      ForeignTradeByProductsBaseInfo,
      ForeignTradeByProductsTable,
    },
    mixins: [security],
    data(): {
      filter: TForeignTradeByProductsFilter;
      filterForExport: TForeignTradeByProductsFilter;
      defaultFilter: TForeignTradeByProductsFilter;
    } {
      return {
        filter: { ...DEFAULT_FILTER },
        filterForExport: { ...DEFAULT_FILTER },
        defaultFilter: { ...DEFAULT_FILTER },
      };
    },
    mounted() {
      this.checkPermissionAndRedirect(this.getPermissions.view);
    },
    computed: {
      getPermissions(): TAggregatedPermissions {
        return {
          view: constants.Permissions.ForeignTradeAnalyticsRegionByProductsView,
          build: constants.Permissions.ForeignTradeAnalyticsRegionByProductsBuild,
          export: constants.Permissions.ForeignTradeAnalyticsRegionByProductsDownload,
        };
      },

      getExportConfig(): TExportConfig {
        return {
          pdfFileName: this.getFileName(this.filter),
          excelFileName: this.getFileName(this.filterForExport),
          excel: {
            permissionCode: this.getPermissions.export,
            url: links.ved.foreignTrade.products.exportExcel,
            params: this.filterForExport,
          },
        };
      },
    },
    methods: {
      searchFilter(filter: Partial<TForeignTradeByProductsFilter>) {
        this.filter = { ...this.filter, ...filter };
      },
      updateFilter(filter: Partial<TForeignTradeByProductsFilter>) {
        this.filterForExport = { ...this.filterForExport, ...filter };
      },
      getFileName(filter: TForeignTradeByProductsFilter) {
        return getFilenameWithPeriod('Внешняя_торговля_субъекта_РФ_в_разрезе_товаров', filter.periods);
      },
    },
  });
